import React, { useEffect, useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Redirect, useParams} from 'react-router-dom';
import Rating from '../components/Rating';
import { fetchProduct, removeSelectedProduct } from '../redux/product/productActions';
import { addItem } from '../redux/cart/cartActions';

const ProductScreen = () => {

    const {id} = useParams();
    const selectedId = id;

    const [qty, setQty] = useState(1);
    const [redirect, setRedirect] = useState(false);

    const productReducer = useSelector(state => state.productReducer)
    const {product} = productReducer
    const dispatch = useDispatch();

    useEffect(() =>{
        dispatch(fetchProduct(selectedId));

        return () => {
            dispatch(removeSelectedProduct());
        }
    },[dispatch, selectedId])
    
    const addHandler = (product) =>{
        const newItem = {product, qty};
        dispatch(addItem(newItem))
        setRedirect(true);
        setQty(1);
    }

    if(redirect){
        return <Redirect to="/cart"/>
    }
    
    return (product && (
        <div id="product-screen" className="pageContainer">
            <div className="pageHeader">
                {product.name}
            </div>
            
            <div className="pageBody product-details">
                <div className="col">
                    <img src={product.image} alt={product.name}/>
                </div>

                <div className="col">
                    <Rating value={product.rating} text={`${product.numReviews} reviews`}/>
                    
                    <p className="col-item"><b>Description</b> : {product.description}</p>
                    <table className="col-item">
                        <tbody>
                            <tr>
                                <td><b>Brand</b></td>
                                <td>{product.brand}</td>
                            </tr>
                            <tr>
                                <td><b>Category</b></td>
                                <td>{product.category}</td>
                            </tr>
                            <tr>
                                <td><b>Stock Left</b></td>
                                <td>{product.countInStock}</td>
                            </tr>
                        </tbody>
                    </table>

                    Qty : <select value={qty}
                        onChange={(e) => setQty(e.target.value)}>
                            {[...Array(product.countInStock).keys()].map(
                              (x) => (
                                <option key={x + 1} value={x + 1}>
                                  {x + 1}
                                </option>
                              )
                            )}
                    </select>

                    <h2 className="col-item">₹ {product.price}</h2>
                    
                    <button className="col-item btn" 
                        disabled={product.countInStock === 0}
                        onClick={() => addHandler(product)}>
                        Add To Cart
                    </button>
                </div>
                
                {/* <div className="review-form">
                    <input placeholder="Write a product review"/>
                    {product.reviews && product.reviews.map(review => <h3>{review.name}</h3>)}
                </div> */}
{/* //   {name, rating, comment , user} */}
            </div>


        </div>
    ))
};

export default ProductScreen;
